import React, { useEffect, useState } from 'react';
import { Form, Input, Button, message, Radio } from 'antd';
import { getMsgCodeRequest } from '../../api/request';
import RadioGroup from '../../components/RadioGroup';
import Icon from '../../components/Icon';
import { useRef } from 'react';
import ImgCodeModal from '../ImgCodeModal';

/**
 * 手机验证(或绑定)
 * @param {*} props 
 * @returns 
 */

function MobileVerify(props) {
  const {
    title, // 标题
    phoneNumber = '', // 默认的手机号
    expires,
    okText = '确认', // 确认按钮文字
    setShow = () => {},
    onOk = () => {}, // 确认回调用
    onCancel = () => {} // 取消回调
  } = props;
  const [msgCode, setMsgCode] = useState({});
  const [openImgCodeModal, setOpenImgCodeModal] = useState(false);
  const [phoneValue, setPhoneValue] = useState('');
  const [form] = Form.useForm();
  const reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
  const [countTime, setCountTime] = useState(60);
  const timer = useRef(null);
  const  [showCount, setShowCount]= useState(false)

  // 点击确认提交表单
  const onFinish = (values) => {
    const payload = {
      ...values,
      captcha_session_id: msgCode.id
    }
    onOk(payload);
  }

  // 处理点击获取验证码
  const handleClickSendMsgCode = () => {
    if (showCount) {
      return;
    }
    form.validateFields(['phone_number']).then(() => {
      setOpenImgCodeModal(true);
    });
  }

  //发送短信验证码
  const sendMsgCode = async (imgCodeValue, safeCode) =>{
    if(!reg.test(phoneValue)) {
      message.error('请输入正确的手机号码');
      return;
    }
    const payload = {
      captcha:imgCodeValue,
      // "captcha_length": 0,
      "captcha_type": 0,
      "description": "",
      captcha_session_id: safeCode.id,
      expires,  // 默认2小时过期 0为不过期 大于0为设置的时间
      phone_number:phoneValue
    };

    getMsgCodeRequest(payload).then((res)=>{
      const {code,message:msg,data} = res
      if(code === 'SUCCESS'){
        message.success('发送成功');
        setOpenImgCodeModal(false)
        setMsgCode(data)
        //开启倒计时
        setShowCount(true)
      }else{
        message.error(msg)
      }
    }).catch(err => {
      message.error(err)
    })

  }
  useEffect(() => {
    if (showCount ) {
      timer.current = setInterval(() => {
        if (countTime < 1) {
          setShowCount(false);
          clearInterval(timer.current);
          setCountTime(60);
          return;
        }
        setCountTime(countTime - 1);
      }, 1000);
    }
    return () => {
      clearInterval(timer.current);
    };
  }, [showCount, countTime]);

  useEffect(() => {
    if (phoneNumber) {
      form.setFieldValue('phone_number', phoneNumber);
      setPhoneValue(phoneNumber);
    }
  }, [phoneNumber])

  useEffect(() => {
    // 默认清除浏览器直接带入的验证码
    form.setFieldValue('captcha', '') 
  }, [])

  return (
    <>
      <div className='login-info fixed'>
        <div className='login-info-container'>
            <div className='switch-container'>
              <RadioGroup>
                <Radio value={1} checked>{title}</Radio>
              </RadioGroup>
            </div>
            <Form
                className="login-form"
                onFinish={onFinish}
                form={form}
              >
                <Form.Item
                  name="phone_number"
                  rules={[{ required: true, message: '请输入手机号!' }, { pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, message: '请输入正确手机号!' }]}
                >
                  <Input
                     prefix={<Icon name="phone"/>} 
                     placeholder="请输入手机号" 
                     disabled={!!phoneNumber}
                     onChange={(v)=>{
                      setPhoneValue(v.target.value)
                    }} 
                  />
                </Form.Item>
            
                <Form.Item
                  className='phone-code-box'
                >
                  <div className='phone-code-flex'>
                    <Form.Item
                    name="captcha"
                    rules={[{ required: true, message: '请输入短信验证码!' }]}
                    className='phone-code'
                  >
                      <Input
                        prefix={<Icon name="guard"/>}
                        type="password"
                        placeholder="请输入短信验证码"
                        autoComplete='off'
                      />
                    </Form.Item>
                    <span className={`get-code ${showCount?'get-code-disable':''}`} onClick={handleClickSendMsgCode}> 
                        {showCount
                  ? `${countTime}秒后重新获取`
                  : '获取验证码'}
                  </span>
                  </div>
                </Form.Item>
                <Form.Item className='submit-item'>
                  <Button className="login-form-button btn-cancel" 
                    onClick={() => {
                      onCancel();
                      setShow(false);
                    }}
                  >
                    取消
                  </Button>
                  <Button type="primary" htmlType="submit" className="login-form-button">
                    {okText}
                  </Button>
                </Form.Item>
              </Form>
          </div>
      </div>
      {
        openImgCodeModal ?
        <ImgCodeModal 
          open={openImgCodeModal}
          setOpen={setOpenImgCodeModal}
          onOk={sendMsgCode}
        />
        : null
      }
    </>
  )
}

export default MobileVerify;